import { Group, Text, Circle } from 'react-konva';
import { calcOutputPos, width } from './WorkflowItem';
import WorkflowItemOutputValue from '../calculate/WorkflowItemOutputValue';

function OutputPin(props) {
	const { index, name, max, onOutputClick, onOutputDblClick, onOutputCircleDblClick, transformer, itemHeight, enabled, minified } = props;
	const pos = calcOutputPos(itemHeight, index, max);

	return (
		<Group>

			<Text text={name} fontSize={9} fill="black" opacity={enabled ? 1 : 0.3} listening={false} x={pos.x - 15 - width} y={pos.y - 4} width={width} align="right" onDblClick={() => onOutputDblClick()} />

			{enabled && <Circle x={pos.x} y={pos.y} fill={minified ? '#cccccc' : '#1b2330'} radius={5} hitStrokeWidth={5} /*onPointerClick={() => onOutputClick(name, pos)}*/ onPointerClick={() => onOutputClick(name, pos)} onDblClick={(evt) => { evt.cancelBubble = true; onOutputCircleDblClick(name, pos); }} />}

			<WorkflowItemOutputValue transformer={transformer} name={name} x={pos.x - 12 - 100} y={pos.y - 4} width={100} height={10} />

		</Group>
	);
}

export default OutputPin;